module.exports = __webpack_public_path__ + "static/cardFacebook-8ff8025a76ddc3d42e87d7b07740d78f.png";